import { EbayListingPolicyResponse } from "./ebayPolicyModels/ebayPolicyModel";

export class BaseMarketplaceAccountRequest {
  id: number = 0;
  name: string = '';
  userName: string = '';
  accessToken: string | null = '';
  accessTokenExpireAt: Date = new Date();
  refreshToken: string | null = '';
  refreshTokenExpireAt: Date = new Date();
  status: MarketplaceAccountStatus = 0;
  marketplace: number = 0;
  marketplaceName: string = '';
  ebayListingPolicies: EbayListingPolicyResponse[] = [];
  companyId: number = 0;
  default: boolean = false;
}

export class CreateMarketplaceAccountRequest extends BaseMarketplaceAccountRequest {
}

export class MarketplaceAccountResponse extends BaseMarketplaceAccountRequest {
  accessTokenStatus: string = '';
  refreshTokenStatus: string = '';
  accessTokenExpiryTime: Date = new Date();
  refreshTokenExpiryTime: Date = new Date();
  createdAt: Date = new Date();
  createdById: number = 0;
  lastModifiedAt: Date = new Date();
  lastModifiedById: number = 0;
}
export class MarketplaceAccountLiteResponse {
  id: number = 0;
  name: string = '';
  userName: string = '';
  marketplace: number = 0;
  marketplaceName: string = '';
}
export class PaginatedMarketplaceAccountsResponse {
  totalCount: number = 0;
  pageNumber: number = 1;
  pageSize: number = 15;
  items: MarketplaceAccountResponse[] = []
}
export enum MarketplaceAccountStatus {
  Unknown = 0,
  AccountNotSynced,
  PoliciesNotSynced,
  Complete
}

export enum MarketplaceIntegrations {
  eBay = 1,
  Goodwill_Finds,
  Poshmark,
  Shop_Goodwill,
  Thrift_Spotter
}
